export const LOCAL_STORAGE_KEY_PERMISSIONS = "permissions"
export const LOCAL_STORAGE_KEY_BANNERS = "banners"
export const LOCAL_STORAGE_KEY_USER = "users"

export const LOCAL_STORAGE_KEY_DEALERS_DEBT_HANDLE = "debt_handle"

export const LOCALSTORAGEKEY_DEALERS_ECONOMIC_GROUPS = "dealers_economic_groups";
export const LOCAL_STORAGE_KEY_ACCESS_POINT = "access_point"
